import { c as _c } from "react/compiler-runtime";
import { IcoDatabase16, IcoFileText16, IcoGridMasonry16, IcoShield16, IcoWarning16 } from '@onefootprint/icons';
import type { DocumentViewerCard, TabGroupKind } from '@onefootprint/request-types/dashboard';
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
type TabNavigationProps = {
  groupedCards: Record<TabGroupKind, DocumentViewerCard[]>;
  selectedTab: TabGroupKind;
  onTabChange: (tab: TabGroupKind) => void;
};
const TAB_CONFIG: Array<{
  kind: TabGroupKind;
  Icon: typeof IcoShield16;
}> = [{
  kind: 'validation',
  Icon: IcoShield16
}, {
  kind: 'extraction',
  Icon: IcoFileText16
}, {
  kind: 'tamper_detection',
  Icon: IcoWarning16
}, {
  kind: 'classification',
  Icon: IcoGridMasonry16
}, {
  kind: 'vault_data',
  Icon: IcoDatabase16
}];
const TabNavigation = t0 => {
  const $ = _c(23);
  const {
    groupedCards,
    selectedTab,
    onTabChange
  } = t0;
  const {
    t
  } = useTranslation("document-viewer");
  let t1;
  if ($[0] !== t) {
    t1 = t(_temp);
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t(_temp2);
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t(_temp3);
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t(_temp4);
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t(_temp5);
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = {
      validation: t1,
      extraction: t2,
      tamper_detection: t3,
      classification: t4,
      vault_data: t5
    };
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const tabLabels = t6;
  let t7;
  if ($[16] !== groupedCards || $[17] !== onTabChange || $[18] !== selectedTab || $[19] !== tabLabels) {
    t7 = TAB_CONFIG.map(t8 => {
      const {
        kind,
        Icon
      } = t8;
      const cardCount = groupedCards[kind].length;
      const isSelected = selectedTab === kind;
      const isEmpty = cardCount === 0;
      return <li key={kind} className="shrink-0 md:shrink"><button type="button" onClick={() => onTabChange(kind)} disabled={isEmpty} className={cx("w-full text-left px-3 py-2 rounded-md flex items-center gap-2 transition-colors whitespace-nowrap md:whitespace-normal", {
          "bg-senary/75": isSelected,
          "hover:bg-hover": !isSelected && !isEmpty,
          "opacity-50 cursor-not-allowed": isEmpty
        })}><Icon className={cx({
            "text-primary": isSelected,
            "text-tertiary": !isSelected
          })} /><span className={cx({
            "text-label-2 text-primary": isSelected,
            "text-body-2 text-tertiary": !isSelected
          })}>{tabLabels[kind]}</span></button></li>;
    });
    $[16] = groupedCards;
    $[17] = onTabChange;
    $[18] = selectedTab;
    $[19] = tabLabels;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t7) {
    t8 = <nav className="flex-1 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden md:overflow-x-visible"><ul className="flex gap-1 md:flex-col">{t7}</ul></nav>;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
};
export default TabNavigation;
function _temp($) {
  return $.tabs.validation;
}
function _temp2($_0) {
  return $_0.tabs.extraction;
}
function _temp3($_1) {
  return $_1.tabs.tamperDetection;
}
function _temp4($_2) {
  return $_2.tabs.classification;
}
function _temp5($_3) {
  return $_3.tabs.vaultData;
}